import { API } from "../api";

const getActivityBase = (guard = "investor") => {
  if (guard === "member") return "/members/activity";
  if (guard === "staff") return "/cooperatives/activity";
  return "/investors/activity";
};

const activityApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getActivityFeed: builder.query({
      query: ({
        guard = "investor",
        page = 1,
        per_page = 20,
        category = "",
        from = "",
        to = "",
        search = "",
      } = {}) => {
        const params = new URLSearchParams({
          guard,
          page: String(page),
          per_page: String(per_page),
        });
        if (category && category !== "all") params.set("category", category);
        if (from) params.set("from", from);
        if (to) params.set("to", to);
        if (search) params.set("search", search);
        return `${getActivityBase(guard)}?${params.toString()}`;
      },
      transformResponse: (responseData) => {
        const payload = responseData?.data || {};
        return {
          items: Array.isArray(payload.data) ? payload.data : [],
          meta: payload.meta || {},
        };
      },
      providesTags: [{ type: "Activity", id: "LIST" }],
    }),
  }),
});

export const { useGetActivityFeedQuery } = activityApi;
